import { useAuthStore } from '../../store';
import View from '../../components/view/view';
import { useSettingsStore } from '../../store/settings-store';

import styles from './profile.module.scss';

const ProfileView = () => {
    const { profile } = useAuthStore();
    const { theme } = useSettingsStore();

    return (
        <View theme={theme}>
            <div className={'viewContent'}>
                <h1 className={'view-title'}>Mi perfil</h1>
            </div>
            <dl className={styles.descriptionTable}>
                <div className={styles.row}>
                    <dt>Nombre completo</dt>
                    <dd>
                        {profile?.firstName} {profile?.lastName}
                    </dd>
                </div>
                <div className={styles.row}>
                    <dt>Correo</dt>
                    <dd>{profile?.email}</dd>
                </div>
                <div className={styles.row}>
                    <dt>Rol</dt>
                    <dd>{profile?.role?.displayName}</dd>
                </div>
            </dl>
        </View>
    );
};

export default ProfileView;
